import { fetchDraftPosts } from './fetch-draft-posts';
import { fetchPublishedPosts } from './fetch-published-posts';
export const fetchBlogPosts = async (httpClient, errorHandler, ids, isExperimentEnabled) => {
  const shouldSplitQuery = isExperimentEnabled == null ? void 0 : isExperimentEnabled('specs.seo-data-service.splitDraftAndPostQuery');
  if (shouldSplitQuery) {
    const [publishedPosts, draftPosts] = await Promise.all([fetchPublishedPosts(httpClient, errorHandler, ids), fetchDraftPosts(httpClient, errorHandler, ids)]);
    return [...publishedPosts, ...draftPosts];
  } else {
    return fetchDraftPosts(httpClient, errorHandler, ids);
  }
};
//# sourceMappingURL=fetch-blog-posts.js.map